import { isNil } from 'lodash';
import { Dayjs } from 'dayjs';
import type { Nullable } from '../../types/common';
import type { CapacityValues } from '../../types/components/filter_bar_types';

interface BuildAvailableSpacesParams {
  organizationSlug?: string;
  venueSlug?: string;
  startDate: Nullable<Dayjs>;
  startOffset: Nullable<number>;
  endOffset: Nullable<number>;
  capacityFilterValues: CapacityValues;
}

interface AvailableSpacesRequest {
  organizationSlug?: string;
  venueSlug?: string;
  startDate?: Date;
  startOffset?: number;
  endOffset?: number;
  seated?: number[];
  standing?: number[];
}

export const buildAvailableSpacesRequest = (
  params: BuildAvailableSpacesParams,
) => {
  const {
    organizationSlug,
    venueSlug,
    startDate,
    startOffset,
    endOffset,
    capacityFilterValues,
  } = params;

  const req: AvailableSpacesRequest = {
    organizationSlug: organizationSlug,
    venueSlug: venueSlug,
  };

  if (!isNil(startDate)) {
    req.startDate = startDate.toDate();
  }

  if (!isNil(startOffset)) {
    req.startOffset = startOffset;
  }

  if (!isNil(endOffset)) {
    req.endOffset = endOffset;
  }

  const capacityRange = [
    capacityFilterValues.minGuests ?? 0,
    capacityFilterValues.maxGuests ?? 0,
  ];

  const seatedOrStanding = capacityFilterValues.allowSeated === capacityFilterValues.allowStanding;

  if (capacityFilterValues.allowSeated || seatedOrStanding) {
    req.seated = capacityRange;
  }
  if (capacityFilterValues.allowStanding || seatedOrStanding) {
    req.standing = capacityRange;
  }

  return req;
};
